import {
  CertBasicInfo,
  CertDetailsResponse,
  CertRecord,
  Part3Record,
} from '../types/cert';

export const generateData = (count: number, prefix: string): CertRecord[] => {
  return Array.from({ length: count }, (_, i) => ({
    code: `${prefix} ${i + 1}`,
    location: `location ${i + 1}`,
    condition: `Conforms with FSD requirements`,
    completionDate: `20/01/2026`,
    nextDueDate: `20/01/2026`,
  }));
};

export const generatePart3Data = (): Part3Record[] => {
  return Array.from({ length: 7 }, (_, i) => ({
    code: `${2 * (i + 1)} Automatic Actuating Device`,
    location: `location ${i + 1}`,
    outstandingDefects: `defect ${i + 1}`,
    commentOnDefects: `comment ${i + 1}`,
    notification: "",
  }));
};

export const generateBasicInfo = (): CertBasicInfo => ({
  fsdRcNumber: 'RC1/0401',
  companyName: 'Company A',
  username: 'Account002',
  serialNumber: '10401 260120',
  nameOfClient: 'client abc',
  typeOfBuilding: 'Industrial Building',
  displayAddress:
    'Flat 2, Floor 1, COS CENTRE, 56 TSUN YIP STREET, KWUN TONG DISTRICT, Kowloon',
  typeOfPremises: 'Club',
});

export const generateCertDetailsMock = (): CertDetailsResponse => ({
  basicInfo: generateBasicInfo(),
  part1Data: generateData(1, '1 Audio/Visual Advisory System'),
  part2Data: generateData(5, '2 Installation / Modification System'),
  part3Data: generatePart3Data(),
});
